import { render, staticRenderFns } from "./CompetitionActivitiesCheckbox.vue?vue&type=template&id=05886c45&"
import script from "./CompetitionActivitiesCheckbox.vue?vue&type=script&lang=js&"
export * from "./CompetitionActivitiesCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports